<template>
  <div>
    <!-- Table Container Card -->
    <b-card>
      <div>
        <b-row>
          <b-col md="4">
            <b-form-input
              v-model="searchQuery.driverId"
              placeholder="Driver ID"
              @keypress.enter="applyQuickSearch"
              @input="(val) => (searchQuery.driverId = val)"
            />
          </b-col>
          <b-col md="4">
            <b-form-datepicker
              v-model="searchQuery.startDate"
              placeholder="Start Date"
              class="mb-0"
              @input="applyQuickSearch"
            />
          </b-col>
          <b-col md="4">
            <b-form-input
              v-model="searchQuery.driverPhone"
              placeholder="Driver Phone"
              @keypress.enter="applyQuickSearch"
              @input="(val) => (searchQuery.driverPhone = val)"
            />
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="2">
            <b-button variant="outline-danger" @click="clearAllFilters">
              Clear All Filters
            </b-button>
          </b-col>
          <b-col
            cols="6"
            class="mt-2 mt-md-0 d-flex justify-content-center"
            md="2"
          >
            <b-button
              class="btn-icon rounded-circle ml-1"
              variant="flat-primary"
              @click="fetchLivenessChecks"
            >
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingLivenessChecks"
      >
        <b-table
          ref="refLivenessCheckListTable"
          class="position-relative text-center"
          :items="livenessChecks"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No liveness check records found. Try adjusting your search filters."
        >
          <!-- Column: External ID -->
          <template #cell(driverId)="data">
            <b-link
              v-if="data.item.driver_id"
              :to="{
                name: 'drivers-view',
                params: { id: data.item.driver_id },
                query: { externalId: data.item.driver_external_id },
              }"
              target="_blank"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.driver_external_id }}
            </b-link>
            <span v-else>
              {{ data.item.driver_external_id || "N/A" }}
            </span>
          </template>

          <!-- Column: Date & Time -->
          <template #cell(dateTime)="data">
            <span class="text-nowrap">
              {{ formatDate(data.item.created_at) }}
            </span>
          </template>

          <!-- Column: Driver Phone -->
          <template #cell(driverPhone)="data">
            <span class="text-nowrap">
              {{ data.item.driver_phone || "N/A" }}
            </span>
          </template>

          <!-- Column: Status -->
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.state"
              pill
              :variant="getStatusVariant(data.item.state)"
              class="text-capitalize"
            >
              {{ data.item.state }}
            </b-badge>
          </template>

          <!-- Column: Video URL -->
          <template #cell(videoUrl)="data">
            <b-button
              v-if="data.item.video_url"
              variant="outline-primary"
              size="sm"
              @click="openVideoUrl(data.item.video_url)"
              class="btn-icon"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
            <span v-else class="text-muted">N/A</span>
          </template>
        </b-table>
      </b-overlay>
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalLivenessChecks"
        :per-page-options="perPageOptions"
        @change="fetchLivenessChecks"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BButton,
  BTable,
  BLink,
  BBadge,
  BOverlay,
} from "bootstrap-vue";
import BasePagination from "@/UI/BasePagination.vue";
import useLivenessCheckList from "./useLivenessCheckList";
import livenessCheckStoreModule from "./livenessCheckStoreModule";
import useRegisterStoreModule from "@/hooks/useRegisterStoreModule";
import formatDate from "@/utils/date-format";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    BButton,
    BTable,
    BLink,
    BBadge,
    BOverlay,
    BasePagination,
  },
  setup() {
    useRegisterStoreModule("livenessCheck", livenessCheckStoreModule);

    const {
      fetchLivenessChecks,
      livenessChecks,
      tableColumns,
      perPage,
      currentPage,
      totalLivenessChecks,
      perPageOptions,
      searchQuery,
      refLivenessCheckListTable,
      loadingLivenessChecks,
      getStatusVariant,
    } = useLivenessCheckList();

 

    const clearAllFilters = () => {
      searchQuery.value = {
        driverId: "",
        startDate: "",
        driverPhone: "",
      };
      currentPage.value = 1;
      fetchLivenessChecks();
    };

    const openVideoUrl = (url) => {
      window.open(url, "_blank");
    };

    const applyQuickSearch = () => {
      currentPage.value = 1;
      fetchLivenessChecks();
    };

    fetchLivenessChecks();

    return {
      fetchLivenessChecks,
      livenessChecks,
      tableColumns,
      perPage,
      currentPage,
      totalLivenessChecks,
      perPageOptions,
      searchQuery,
      refLivenessCheckListTable,
      loadingLivenessChecks,
      applyQuickSearch,
      clearAllFilters,
      getStatusVariant,
      formatDate,
      openVideoUrl,
    };
  },
};
</script>
